import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News007() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.7.p1'),
        t('news:news.7.p2'),
        t('news:news.7.p3'),
        t('news:news.7.p4'),
        t('news:news.7.p5'),
        t('news:news.7.p6'),
        t('news:news.7.p7')
    ]

    const newsImage = [
        "news007-img1.jpg",
        "news007-img2.jpg",
        "news007-img3.jpg",
        "news007-img4.jpg",
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2026-05-06"
                headline={t('news:headline.7')}
            />
        </div>
    )
}